/* SmartPaw — A/B test bundelkeuze, ronde 2 (tijdelijk, t.e.m. 18 november)

   TABEL  = vergelijkingstabel. Alle kopstukken als rijen, de drie sets als
            kolommen. Je ziet meteen wat je bij elke set wel en niet krijgt.
   REGELS = drie dunne regels met naam en prijs. Tik je er een aan, dan klapt
            de inhoud eronder open.

   De keuze valt in de browser (50/50) en blijft in localStorage staan.
   Zelf bekijken kan met ?ab=tabel of ?ab=regels achter de URL.

   De tabel wordt in de browser gebouwd uit de bestaande setkaarten. Die
   kaarten blijven in de pagina staan, alleen onzichtbaar, zodat de prijzen,
   de kortingen en de winkelmand exact blijven werken zoals ze nu werken.
   Een klik op een kolom klikt gewoon de echte kaart aan.

   Lukt het bouwen niet, dan valt alles terug op de originele weergave en
   krijgt de bestelling het kenmerk FOUT mee, zodat we dat in de cijfers zien.

   Deze code staat bewust in een apart bestand en niet in de pagina zelf:
   vertaalhulpjes in de browser kunnen de inhoud van een <script> in de
   pagina soms als gewone tekst tonen. Een verwijzing naar een bestand
   heeft geen tekst om te tonen. */



/* ---------- 1. welke versie ---------- */

(function () {
  var K = 'sp_ab_bundel2', v = null;
  var MAP = { tabel:'tabel', regels:'regels', '1':'tabel', '2':'regels' };
  try {
    var q = (location.search.match(/[?&]ab=([a-z0-9]+)/i) || [])[1];
    if (q && MAP[q.toLowerCase()]) { v = MAP[q.toLowerCase()]; localStorage.setItem(K, v); }
    else { v = localStorage.getItem(K); }
  } catch (e) {}
  if (v !== 'tabel' && v !== 'regels') {
    v = Math.random() < 0.5 ? 'tabel' : 'regels';
    try { localStorage.setItem(K, v); } catch (e) {}
  }
  document.documentElement.setAttribute('data-ab-bundel', v);
  window.SP_AB_BUNDEL = v;
})();

/* ---------- 2. de vergelijkingstabel bouwen ---------- */

(function () {
  if (window.__spAbTabel) return;
  window.__spAbTabel = true;

  /* Korte namen voor de tabelrijen. Staat een naam hier niet in, dan wordt
     hij automatisch ingekort. Wil je een andere afkorting: zet ze hier bij,
     of pas de korte namen aan bij de set in de thema-editor. */
  var KORT = {
    'Basiseenheid': 'Basis',
    'Ondervachtkam': 'Ondervacht',
    'Ondervachtborstel': 'Ondervacht',
    'Naaldenkam': 'Naalden',
    'Massagekam': 'Massage',
    'Massageborstel': 'Massage',
    '2-in-1 Platte borstel': 'Platte',
    'Antistatische borstel': 'Antistat.',
    'Trimmer': 'Trimmer',
    'Opbergstuk voor accessoires': 'Opberg',
    'Opbergstandaard': 'Opberg'
  };

  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  function kortItem(n) {
    if (KORT[n]) return KORT[n];
    if (/filter/i.test(n)) return 'Filters';
    var w = n.replace(/\(.*?\)/g, ' ').split(/\s+/).filter(Boolean);
    while (w.length > 1 && /\d/.test(w[0])) { w.shift(); }
    var s = w[0] || n;
    if (s.length < 4 && w[1]) { s = s + ' ' + w[1]; }
    return s.length > 14 ? s.slice(0, 13) + '…' : s;
  }

  function kortSet(n) {
    var s = n.replace(/[\s\-]*set$/i, '').trim();
    if (/gs$/i.test(s)) { s = s.slice(0, -1); }
    return s || n;
  }

  function prijs(card) {
    var p = card.querySelector('.fvs-price');
    if (!p) return '';
    var c = p.cloneNode(true);
    var junk = c.querySelectorAll('.fvs-was, .fvs-savepill');
    for (var i = 0; i < junk.length; i++) { junk[i].parentNode.removeChild(junk[i]); }
    return txt(c);
  }

  function itemNaam(it) {
    var img = it.querySelector('img');
    var alt = img && (img.getAttribute('alt') || '').trim();
    if (alt) return alt;
    var d = it.querySelector('.fvs-dealname');
    var src = d || it.querySelector('span');
    if (!src) return '';
    var c = src.cloneNode(true);
    var junk = c.querySelectorAll('.fvs-dealtag, .fvs-dealsub, s');
    for (var i = 0; i < junk.length; i++) { junk[i].parentNode.removeChild(junk[i]); }
    return txt(c);
  }

  function markeerFout() {
    document.documentElement.setAttribute('data-ab-bundel', 'fout');
    window.SP_AB_BUNDEL = 'fout';
    /* De meting staat op dit moment al op TABEL in de winkelmand. Nu de tabel
       niet gebouwd raakte moet dat FOUT worden, dus meteen bijwerken. */
    if (typeof window.__spAbSchrijf === 'function') { window.__spAbSchrijf(); }
  }

  function bouwTabel() {
    var wrap = document.querySelector('.fvs-wrap');
    if (!wrap) return false;
    var lijst = wrap.querySelector('.fvs-list:not(.fvs-list--ship)');
    if (!lijst) return false;
    if (wrap.querySelector('.spt-wrap')) return true;

    var alle = [].slice.call(lijst.querySelectorAll('.fvs-card[data-set]'));
    var kaarten = alle.filter(function (c) { return c.getAttribute('data-builder') !== 'true'; });
    if (kaarten.length < 2) return false;

    var rijen = [], index = {};
    var kolommen = kaarten.map(function (c) {
      var items = {};
      var els = c.querySelectorAll('.fvs-items .fvs-item');
      for (var i = 0; i < els.length; i++) {
        var it = els[i];
        var naam = itemNaam(it);
        if (!naam) continue;
        var soort = it.className.indexOf('fvs-item--free') > -1 ? 'free'
                  : it.className.indexOf('fvs-item--deal') > -1 ? 'deal' : 'ja';
        items[naam] = { soort: soort, tag: soort === 'deal' ? txt(it.querySelector('.fvs-dealtag')) : '' };
        if (!(naam in index)) { index[naam] = rijen.length; rijen.push({ naam: naam, extra: soort !== 'ja' }); }
        else if (soort !== 'ja') { rijen[index[naam]].extra = true; }
      }
      var bd = c.querySelector('.fvs-badge');
      return {
        kaart: c,
        items: items,
        naam: txt(c.querySelector('.fvs-name')),
        badge: txt(bd),
        badgeKleur: bd ? (bd.style.backgroundColor || '') : '',
        was: txt(c.querySelector('.fvs-was')),
        prijs: prijs(c)
      };
    });

    if (!rijen.length) return false;

    /* gewone onderdelen eerst, cadeau en setkorting onderaan */
    var gewoon = [], extra = [];
    for (var r = 0; r < rijen.length; r++) { (rijen[r].extra ? extra : gewoon).push(rijen[r]); }
    rijen = gewoon.concat(extra);

    var h = '<div class="spt-wrap"><table class="spt"><colgroup><col class="spt-c0">';
    for (var k = 0; k < kolommen.length; k++) { h += '<col>'; }
    h += '</colgroup><thead><tr><th></th>';
    kolommen.forEach(function (col, ci) {
      h += '<th data-c="' + ci + '"><button type="button" class="spt-btn" data-c="' + ci + '" title="' + col.naam.replace(/"/g, '') + '">';
      if (col.badge) {
        h += '<span class="spt-bd"' + (col.badgeKleur ? ' style="background:' + col.badgeKleur + '"' : '') + '>' + col.badge + '</span>';
      }
      h += '<span class="spt-nm">' + kortSet(col.naam) + '</span>';
      h += '<span class="spt-wa">' + (col.was || '') + '</span>';
      h += '<span class="spt-pr">' + col.prijs + '</span>';
      h += '</button></th>';
    });
    h += '</tr></thead><tbody>';
    rijen.forEach(function (rij) {
      h += '<tr><td class="spt-l">' + kortItem(rij.naam) + '</td>';
      kolommen.forEach(function (col, ci) {
        var st = col.items[rij.naam];
        var cel = '<span class="spt-n">–</span>';
        if (st) {
          if (st.soort === 'free') { cel = '<span class="spt-g">gratis</span>'; }
          else if (st.soort === 'deal') { cel = '<span class="spt-d">' + (st.tag || '✓') + '</span>'; }
          else { cel = '<span class="spt-y">✓</span>'; }
        }
        h += '<td data-c="' + ci + '">' + cel + '</td>';
      });
      h += '</tr>';
    });
    h += '</tbody></table></div>';

    lijst.insertAdjacentHTML('beforebegin', h);
    var tabel = wrap.querySelector('.spt');

    function sync() {
      kolommen.forEach(function (col, ci) {
        var aan = col.kaart.getAttribute('aria-checked') === 'true';
        var cellen = tabel.querySelectorAll('[data-c="' + ci + '"]');
        for (var i = 0; i < cellen.length; i++) {
          if (cellen[i].tagName === 'BUTTON') continue;
          if (aan) { cellen[i].className += cellen[i].className.indexOf('on') > -1 ? '' : ' on'; }
          else { cellen[i].className = cellen[i].className.replace(/\s*\bon\b/g, ''); }
        }
      });
    }

    var knoppen = tabel.querySelectorAll('.spt-btn');
    for (var b = 0; b < knoppen.length; b++) {
      knoppen[b].addEventListener('click', function () {
        var ci = +this.getAttribute('data-c');
        kolommen[ci].kaart.click();
        setTimeout(sync, 0);
      });
    }

    if (window.MutationObserver) {
      var mo = new MutationObserver(sync);
      kolommen.forEach(function (col) {
        mo.observe(col.kaart, { attributes: true, attributeFilter: ['aria-checked'] });
      });
    }
    sync();
    return true;
  }

  function start() {
    if (window.SP_AB_BUNDEL !== 'tabel') return;
    var pogingen = 0;
    (function probeer() {
      var ok = false;
      try { ok = bouwTabel(); } catch (e) { ok = false; }
      if (ok) return;
      if (++pogingen < 25) { setTimeout(probeer, 200); return; }
      markeerFout();
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ---------- 3. de versie meegeven aan de winkelmand ----------

   Het kenmerk wordt nu meteen bij het laden van de pagina gezet, niet meer
   kort na het toevoegen aan de winkelmand. Dat laatste was een race: in
   assets/furvac-sets.js stuurt dezelfde keten de bezoeker na een gelukte
   /cart/add.js direct door (naar after_add, of naar /cart als de
   winkelmandlade niet opengaat). Zijn er geen kortingscodes toe te passen,
   dan gebeurt dat onmiddellijk en lost de pagina op vóór de vertraagde
   /cart/update.js de deur uit is. Op de pre-orderlijn gaat de setcode
   bewust niet mee, dus daar was de codelijst vaak leeg en ging de meting
   stelselmatig verloren.

   Nu staat het kenmerk al in de winkelmand voordat er iets toegevoegd wordt,
   en maakt het niet meer uit hoe snel de pagina daarna wegnavigeert. De haken
   op het toevoegen blijven staan als achtervang, voor het geval de eerste
   poging niet aankwam. Dubbel schrijven kan niet: er gaat alleen een verzoek
   uit als de waarde verschilt van wat er al weggeschreven is. */

(function () {
  if (window.__spAbCartHook) return;
  window.__spAbCartHook = true;

  var laatst = null;   /* laatst met succes weggeschreven waarde */
  var bezig = false;

  function schrijf() {
    var v = window.SP_AB_BUNDEL;
    if (!v) return;
    v = String(v).toUpperCase();
    if (bezig || v === laatst) return;
    bezig = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: { 'Bundeltest': v } })
    })
      .then(function (r) {
        bezig = false;
        if (r && r.ok) { laatst = v; }
      })
      .catch(function () { bezig = false; });
  }

  /* zodat markeerFout() hierboven de waarde kan bijwerken naar FOUT */
  window.__spAbSchrijf = schrijf;

  /* 1. meteen bij het laden van de pagina, zolang de bundelkeuze er staat */
  function bijLaden() {
    if (!document.querySelector('.fvs-wrap')) return;
    schrijf();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bijLaden);
  } else {
    bijLaden();
  }

  /* 2. achtervang: ook na een toevoeging nog eens proberen. Kwam de eerste
        poging aan, dan is laatst al gezet en gaat er niets meer uit. */
  var of = window.fetch;
  if (typeof of === 'function') {
    window.fetch = function (input) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (u.indexOf('/cart/add') > -1) {
        try {
          p.then(function (r) { if (r && r.ok) { schrijf(); } })
           .catch(function () {});
        } catch (e) {}
      }
      return p;
    };
  }

  var oo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    try {
      if (String(u).indexOf('/cart/add') > -1) {
        this.addEventListener('load', function () { schrijf(); });
      }
    } catch (e) {}
    return oo.apply(this, arguments);
  };

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.fvs-wrap [data-add], .fvs-sticky [data-s-btn]')) {
      schrijf();
    }
  }, true);
})();
